import PropTypes from "prop-types";
import { generateFullDeeplinkUrl } from "./experienceUtils";
import FieldPairComponent from "./shared/FieldPairComponent";

const ExperienceComponent = ({ data, inputSchema }) => {
  const partner = data?.partner;
  const sequenceOrder = data?.sequence_order;
  const fullDeeplinkUrl = generateFullDeeplinkUrl(data?.deeplink);

  const partnerTitle = inputSchema?.properties?.partner?.title || "Partner";
  const sequenceOrderTitle =
    inputSchema?.properties?.sequence_order?.title || "Sequence Order";

  return (
    <>
      {partner && (
        <FieldPairComponent label={partnerTitle}>
          <span className="field-value">{partner}</span>
        </FieldPairComponent>
      )}

      {sequenceOrder !== undefined && sequenceOrder !== null && (
        <FieldPairComponent label={sequenceOrderTitle}>
          <span className="field-value">{sequenceOrder}</span>
        </FieldPairComponent>
      )}

      <FieldPairComponent label="Deeplink URL">
        <span
          className="field-value"
          style={{ wordBreak: "break-all", overflowWrap: "anywhere" }}
        >
          {fullDeeplinkUrl}
        </span>
      </FieldPairComponent>
    </>
  );
};

ExperienceComponent.propTypes = {
  data: PropTypes.object,
  inputSchema: PropTypes.object,
};

export default ExperienceComponent;
